export default __webpack_public_path__ + "static/media/header-onboarding-1.a7550888.gif";